module.exports = __webpack_public_path__ + "254b34884c0f70bd9209ecaf4b69fcfc.png";